import { Moon01, Sun } from "@untitledui/icons";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/base/buttons/button";
import { useTheme } from "@/hooks/useTheme";

export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, toggle } = useTheme();
  return (
    <Button
      aria-label={t("shell.toggleTheme")}
      color="tertiary"
      size="sm"
      iconLeading={theme === "light" ? Moon01 : Sun}
      onPress={toggle}
    />
  );
}
